import React, { useEffect, useState } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import { FormattedMessage, useIntl } from "react-intl";
import { useForm } from "react-hook-form";
import * as Form from "@radix-ui/react-form";
import { toast } from "react-toastify";
import { jwtDecode } from "jwt-decode";
import axios from "../../api/axios";
import CustomLabel from "../CustomLabel";
import messages from "./messages";
import {
  Button,
  Container,
  FieldMessage,
  FormField,
  Input,
  NavigationButtons,
  SectionWrapper,
  SpinnerIcon,
} from "../Styles";
import Logo from "../Logo";
import PasswordInput from "./PasswordInput";
import EmailInput from "./EmailInput";
import Header from "../reuse/Header";

function Register() {
  const navigate = useNavigate();

  const {
    register,
    handleSubmit,
    reset,
    watch,
    formState: { errors, isValid, isDirty },
  } = useForm({
    mode: "onChange",
  });
  const params = useParams();

  const [userInfo, setUserInfo] = useState({
    id: "",
    userName: "",
    email: "",
  });

  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  // const [isSubmitted, setIsSubmitted] = useState(false);

  const [loading, setLoading] = useState(false);

  const intl = useIntl();
  const nameMessage = intl.formatMessage(messages.name);
  const emailMessage = intl.formatMessage(messages.email);
  const passwordMessage = intl.formatMessage(messages.password);
  const confirmPasswordMessage = intl.formatMessage(messages.confirm_password);

  const registerMessage = "REGISTER / REGISTRO"; // intl.formatMessage(messages.register);

  // Watch the value of the password field
  const watchPassword = watch("password");

  useEffect(() => {
    try {
      const decoded = jwtDecode(params.token);

      const { id, userName, email } = decoded;
      setUserInfo({
        id,
        userName,
        email,
      });

      reset({
        name: userName,
        email,
      });
    } catch (err) {
      const errorMessage =
        err.response?.data?.message ||
        intl.formatMessage(messages.invalid_token);

      toast.error(errorMessage);
    }
  }, [params]);

  const onSubmit = async (values) => {
    setLoading(true);
    // setIsSubmitted(true);

    try {
      const { name, email, password } = values;

      await axios.post("/auth/register", {
        username: userInfo.userName,
        email: userInfo.email,
        password: btoa(password),
        token: params.token,
      });

      toast.success(intl.formatMessage(messages.registration_success_message));

      navigate("/login", { replace: true });
    } catch (error) {
      const errorMessage =
        error.response?.data?.message || intl.formatMessage(messages.error);

      toast.error(errorMessage);
    } finally {
      setLoading(false);
    }
  };

  const validatePasswordMatch = (value) => {
    return (
      value === watchPassword ||
      intl.formatMessage(messages.passwords_do_not_match)
    );

    /*
    const password = event.target.form.password.value;
    const confirmPassword = event.target.value;
    if (password !== confirmPassword) {
      setError("confirmPassword", {
        type: "manual",
        message: intl.formatMessage(messages.passwords_do_not_match),
      });
    } else {
      clearErrors("confirmPassword");
    }
    */
  };

  return (
    <Container>
      <SectionWrapper width="540px">
        <Logo />
        <Header text={registerMessage} />
        {/* <Header>
          <FormattedMessage {...messages.register} />
        </Header> */}

        <Form.Root onSubmit={handleSubmit(onSubmit)}>
          <FormField name="name">
            <Form.Label>
              <CustomLabel label={nameMessage} required />
            </Form.Label>
            <Form.Control asChild>
              <Input
                type="name"
                {...register("name", {
                  required: nameMessage,
                  disabled: true,
                })}
              />
            </Form.Control>
            {errors?.name && (
              <FieldMessage type="error">{errors?.name.message}</FieldMessage>
            )}
          </FormField>

          <EmailInput
            label={<CustomLabel label={emailMessage} required />}
            name="email"
            register={register}
            readOnly
            errors={errors}
          />

          <PasswordInput
            label={<CustomLabel label={passwordMessage} required />}
            name="password"
            register={register}
            errors={errors}
            showPassword={showPassword}
            setShowPassword={setShowPassword}
          />

          <PasswordInput
            label={<CustomLabel label={confirmPasswordMessage} required />}
            name="confirmPassword"
            register={register}
            errors={errors}
            showPassword={showConfirmPassword}
            setShowPassword={setShowConfirmPassword}
            validatePasswordMatch={validatePasswordMatch}
          />

          <Button type="submit" disabled={!isValid || !isDirty || loading}>
            {loading ? (
              <>
                <SpinnerIcon /> Loading
              </>
            ) : (
              // <FormattedMessage {...messages.submit} />
              "register / registro"
            )}
          </Button>

          <NavigationButtons>
            <Link to="/">
              {/* <FormattedMessage {...messages.login} /> */}
              Login / Acceso
            </Link>
          </NavigationButtons>
        </Form.Root>
      </SectionWrapper>
    </Container>
  );
}

export default Register;
